<template>
    <div class="form form__notification">
        <div class="form__notification_content">
            <template v-if="prefix">
                <div class="form__notification_content_prefix">
                    {{ $t('forms.notification') }}
                </div>
            </template>
            <div class="columns is-vcentered">
                <div class="column">
                    <div class="form__notification_content_description">
                        <div class="form__notification_content_description_name">{{name}}</div>
                        <div
                            v-if="$slots.default"
                            class="form__notification_content_description_slot"
                        >
                            <slot></slot>
                        </div>
                    </div>
                </div>
                <div class="column is-narrow">
                    <div class="form__notification_content_action">
                        <component-button
                            :disabled="disabled"
                            :name="`form-notification-${name}`"
                            :icon="true"
                            :icon-name="'eye'"
                            :icon-raw="true"
                            :theme="''"
                            @click="openNotificationEmail"
                        ></component-button>
                    </div>
                </div>
            </div>
        </div>
        <pop-side
            ref="popnotification"
            :disabled="disabled"
            :title="''"
            :custom-button-active="customButtonActive"
            :cancel-button-text="cancelButtonText"
            :primary-button-text="primaryButtonText"
            @emit-close="clearEmail"
            @emit-custom="resetEmail"
            @emit-primary="submitEmail"
        >
            <pop-side-email
                ref="popnotificationemail"
                :disabled="disabled"
            />
        </pop-side>
    </div>
</template>

<script>
import PopSideEmail from '@/components/default/shared/PopSideEmail'
import PopSide from '@/components/default/shared/PopSide'
import ComponentButton from '@/components/default/shared/ComponentButton'

export default {
  components: { ComponentButton, PopSide, PopSideEmail },
  name: 'form-notification',
  props: {
    prefix: {
      type: Boolean,
      default: true
    },
    name: {
      type: String,
      required: true
    },
    identifier: {
      type: String
    },
    triggerEvent: {
      type: String
    },
    item: {
      type: Object,
      default: () => {
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    customButtonActive: {
      type: Boolean,
      default: true
    },
    cancelButtonText: {
      type: String
    },
    primaryButtonText: {
      type: String
    }
  },
  computed: {
    title () {
      return this.item ? this.item.name : this.name
    },
    emailId () {
      return this.$store.getters.getEmailId
    },
    emailSubdomainId () {
      return this.$store.getters.getEmailOwnerId
    },
    //
    emailUpdateSuccess () {
      return this.$store.getters.getEmailUpdateSuccess
    }
  },
  watch: {
    emailUpdateSuccess () {
      if (this.emailUpdateSuccess === true) {
        this.$refs.popnotification.closePop()
      }
    }
  },
  methods: {
    openNotificationEmail () {
      if (this.item) {
        this.setEmail()
      } else {
        this.getEmail()
      }
      this.$refs.popnotification.openPop()
    },
    closeNotificationEmail () {
      if (this.$refs.popnotification) {
        this.$refs.popnotification.closePop()
      }
    },
    //
    setEmail () {
      this.$store.dispatch('setEmail', this.item)
    },
    getEmail () {
      if (this.identifier) {
        this.$store.dispatch('getEmail', this.identifier)
      } else if (this.triggerEvent) {
        this.$store.dispatch('getEmailByTriggerEvent', this.triggerEvent)
      }
    },
    clearEmail () {
      this.$store.dispatch('clearEmail')
    },
    resetEmail () {
      this.$store.dispatch('resetEmail')
      this.$refs.popnotificationemail.reset()
    },
    submitEmail () {
      const ownerId = this.item ? this.item.ownerId : this.emailSubdomainId
      let dispatchName = ownerId ? 'updateEmail' : 'createEmail'

      this.$store.dispatch(dispatchName).then(() => {
        this.closeNotificationEmail()
        this.$emit('emit-submit')
      }).finally(() => {
        this.$eventBus.$emit('stop-email-submit')
      })
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/forms/formnotification";
</style>
